import { useEffect, useState } from "react";
import { AlarmClock } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Panel } from "./common";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Switch } from "./ui/switch";

export function WakeSetting() {
  const [min, setMin] = useState(null);
  const [on, setOn] = useState(false);
  useEffect(() => { api("/me/sveglia").then((d) => { setOn(d.minuti > 0); setMin(d.minuti || 30); }).catch(() => setMin(30)); }, []);
  const save = async (active = on, value = min) => {
    const m = Math.round(Number(value));
    if (active && (!m || m < 1 || m > 90)) return toast.error("Scegli da 1 a 90 minuti");
    try { await api("/me/sveglia", { method: "PUT", body: { minuti: active ? m : 0 } }); toast.success(active ? `Sveglia attiva ${m} minuti prima del turno` : "Sveglia disattivata"); } catch (e) { toast.error(e.message); }
  };
  if (min === null) return null;
  return (
    <Panel data-testid="wake-setting">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-display font-bold text-lg text-[var(--navy)] flex items-center gap-2"><AlarmClock className="w-5 h-5 text-[var(--teal)]" />Sveglia prima del turno</h2>
        <Switch checked={on} onCheckedChange={(v) => { setOn(v); save(v); }} data-testid="wake-switch" />
      </div>
      <p className="text-sm text-slate-600 mt-1">Con l'app aperta suona un allarme prima dell'inizio di ogni tuo turno (Mare e Uffici), fino a quando non premi Chiudi.</p>
      {on && <div className="flex items-end gap-2 mt-3">
        <div><p className="text-xs text-slate-500 mb-1">Minuti prima (1-90)</p><Input type="number" min="1" max="90" value={min} onChange={(e) => setMin(e.target.value)} className="w-28" data-testid="wake-minutes" /></div>
        <Button className="rounded-full bg-[var(--teal)]" onClick={() => save()} data-testid="wake-save">Salva</Button>
      </div>}
    </Panel>
  );
}
